import React, { useState, useEffect } from "react";

/** Components */
import {
  TableContainer,
  TableHead,
  TextField,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  TableFooter,
  Collapse,
  ButtonGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getCustomers, getSubso, updateSubso } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { convertQueryStringToObject } from "../../../services/libService";
/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

const Subso = () => {
  const location = useLocation();
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getSubso);
  const [isSearchOpen, setSearchOpen] = useState(true);
  //filter
  const filter = convertQueryStringToObject(location.search);
  const [input, setInput] = useState({
    valid_date: filter.valid_date,
    customer: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  ////////
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, customer_id: input.customer?.id, customer: null }));
  };
  const handleUpdateResponse = (res) => {
    fetchData(filter);
  };
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN HẠN THANH TOÁN CỦA KHÁCH HÀNG"));
    fetchData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip>
              <SearchIcon />
            </Tooltip>
          </Button>
          {/* <ButtonWithAPICallComponent title='Đồng bộ dữ liệu' api={() => postSync({ object: 'bacts' })} >
                        <RefreshIcon />
                    </ButtonWithAPICallComponent> */}
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen}>
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getCustomers({ status: 1 })}
          value={input.customer || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue }))}
          label={t("Khách hàng")}
          // eslint-disable-next-line eqeqeq
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id == filter.customer_id) }))}
          triggerSetDefaultFunc={true}
          setDefaultDependencies={[filter.customer_id]}
        />
        <CustomDatePicker label={t("Ngày hiệu lực")} value={input.valid_date} onChange={(value) => setInput((prev) => ({ ...prev, valid_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
        <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
          {t("Tìm kiếm")}
        </Button>
      </Collapse>
      {loading ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>ID</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>SO</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Khách hàng")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Đại lý")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("HTHD")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Ngân hàng")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Phương thức bán")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Loại hình bán")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Tiền tệ")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Chi nhánh")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("TGCN (ngày)")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Thời gian hiệu lực")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Thời gian hết hiệu lực")}</TableCell>
                <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>{t("Trạng thái")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length ? (
                data.map((row, index) => (
                  <TableRow key={row.id} hover style={{ cursor: "pointer" }} onClick={(e) => setSelectedRow(row)}>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.id}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.so_no}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="left">
                      {row.customer_name}
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="left">
                      {row.agent_name}
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.invoice_type}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.bank}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.loading_type}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.saletype}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.currency}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.org_code}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.period}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.effect_date && moment(row.effect_date).format("DD/MM/YYYY")}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }}>{row.exp_date && moment(row.exp_date).format("DD/MM/YYYY")}</TableCell>
                    <TableCell style={{ border: "1px solid lightgray", whiteSpace: "nowrap" }}>{t(row.status)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t(isAllow ? "Không có dữ liệu" : "No permission")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <EditDialog open={Boolean(selectedRow)} onClose={() => setSelectedRow(null)} onSuccess={handleUpdateResponse} initialData={selectedRow} />
    </div>
  );
};

export default Subso;

const EditDialog = ({ open, onClose, onSuccess, initialData }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState(initialData);

  useEffect(() => {
    setInputData(initialData);
  }, [initialData]);
  const handleSave = () => {
    return updateSubso(initialData.id, {
      period: inputData.period,
    });
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      onSuccess && onSuccess(res);
      onClose?.();
    }
  };
  if (inputData)
    return (
      <Dialog open={open} onClose={onClose} align="center">
        <DialogTitle>{t("Chỉnh sửa hạn thanh toán")}</DialogTitle>
        <DialogContent style={{ paddingTop: 10 }}>
          <TextField label={t("Số ngày nợ ")} value={inputData.period || ""} onChange={(e) => setInputData((prev) => ({ ...prev, period: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("Hủy")}</Button>
          <ButtonWithAPICallComponent variant="contained" api={handleSave} response={handleResponse}>
            {t("Lưu")}
          </ButtonWithAPICallComponent>
        </DialogActions>
      </Dialog>
    );
  else return "";
};
